import { createSelector } from 'reselect'

const stories = state => state.stories.stories

export const getStories = createSelector([stories], stories => stories)
export const getIsFetchingStories = createSelector(getStories, ({ isFetching }) => isFetching)
export const getFetchingStoriesError = createSelector(getStories, ({ error }) => error)
export const getStoriesFilterQuery = createSelector(getStories, ({ filterQuery }) => filterQuery)
export const getStoriesAreReversed = createSelector(getStories, ({ reversed }) => reversed)
export const getStoriesList = createSelector(getStories, ({ isFetching, data }) => {
  if (isFetching) return []
  return data.map(story => ({
    id: story.id,
    title: story.title,
    lastUpdated: new Date(story.modified),
    authorEmail: story.author,
    authorFirst: story.author_firstname,
    authorLast: story.author_lastname,
    isPublic: story.is_public,
  }))
})

const FILTER_KEYS_TO_CHECK = ['title', 'authorFirst', 'authorLast']
export const getFilteredStoriesList = createSelector(
  getStoriesList,
  getStoriesFilterQuery,
  (stories, filterQuery) => {
    const queryParts = filterQuery
      .split(' ')
      .filter(s => s)
      .map(s => s.toLowerCase())

    return stories.filter(story =>
      queryParts.every(
        query => FILTER_KEYS_TO_CHECK.some(key => story[key].toLowerCase().includes(query))
      )
    )
  }
)

const currentStory = state => state.stories.currentStory

export const getCurrentStory = createSelector([currentStory], currentStory => currentStory)

const newStory = state => state.stories.newStory

export const getNewStory = createSelector([newStory], newStory => newStory)

export const getIsCreatingNewStory = createSelector([getNewStory], ({ isFetching }) => isFetching)

const updateStory = state => state.stories.updateStory

export const getUpdateStory = createSelector([updateStory], updateStory => updateStory)

const deleteStory = state => state.stories.deleteStory

export const getDeleteStory = createSelector([deleteStory], deleteStory => deleteStory)

const currentStoryCards = state => {
  return state.stories.currentStoryCards
}

export const getCurrentStoryCards = createSelector(
  [currentStoryCards],
  currentStoryCards => currentStoryCards
)

const deleteStoryCard = state => state.stories.deleteStoryCard

export const getDeleteCard = createSelector([deleteStoryCard], deleteStoryCard => deleteStoryCard)

const updatedStoryCard = state => state.stories.updatedStoryCard

export const getUpdateStoryCard = createSelector(
  [updatedStoryCard],
  updatedStoryCard => updatedStoryCard
)
